import React, { useContext, useEffect } from "react";
import { AiOutlineCaretDown, AiFillCaretUp } from "react-icons/ai";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import ParameterContext from "../../context/parameter/parameterContext";
import VTradingContext from "../../context/vTrading/VTradingContext";
import CryptoContext from "../../context/crypto/cryptoContext";

import SellAlert from "../../components/SellAlert";
import Modal from "../../components/Modal";
import _ from "lodash";
const Vtrading = ({ history, location }) => {
  const {
    setColumnName,
    columnName,
    vtButton,
    activePortfolio,
    setActivePortfolioPage,
    vtradingModal,
  } = useContext(ParameterContext);
  const {
    vtradingAlertModal,

    setTotalInvAmount,
    setTotalCurrentAmount,
    currentAmount,
    setTotalNetPL,
    invAmount,
    position,
  } = useContext(VTradingContext);
  const {
    sortGlobalTickerByPrice,
    order,
    sortGlobalTickerBy24h,

    sortGlobalTickerBy7d,
    sortGlobalTickerByName,
    sortGlobalTickerByMarketCap,

    livePriceData,
  } = useContext(CryptoContext);
  // const [close, setClose] = useState(true);
  useEffect(() => {
    if (position?.length > 0 && vtButton === "position") {
      setTotalInvAmount(_.sum(position.map((c) => c.invAmount)));
    }

    if (position?.length > 0 && vtButton === "position") {
      if (livePriceData)
        setTotalCurrentAmount(
          _.sum(position.map((c) => c.amount * livePriceData[c.symbol]))
        );
    }

    // if (currentPortIDDetails?.length === 0) {
    //   setTotalInvAmount(0);
    //   setTotalCurrentAmount(0);
    //   setTotalNetPL(0);
    // }
    //eslint-disable-next-line
  }, [position, livePriceData, activePortfolio]);
  useEffect(() => {
    if (invAmount && currentAmount) {
      setTotalNetPL(currentAmount - invAmount);
    }
    //eslint-disable-next-line
  }, [invAmount, currentAmount]);
  // const currencySymbol = getSymbolFromCurrency(localCurrency!==convt?localCurrency:convt);

  // const handleFavouriteClick = (id) => {
  //   if (isAuthenticated) {
  //     addFavouriteCoin(id);
  //   } else {
  //     toggleModal();
  //   }
  // };
  const positionWidth = [
    "30px",
    "100px",
    "120px",
    "120px",
    "120px",
    "120px",
    "120px",
    "120px",
  ];
  // const historyWidth = [
  //   "30px",
  //   "100px",
  //   "100px",
  //   "120px",
  //   "120px",
  //   "120px",
  //   "200px",
  // ];
  // const openOrdersWidth = [
  //   "100px",
  //   "100px",
  //   "100px",
  //   "200px",
  //   "200px",
  //   "200px",
  // ];
  return (
    <div className="Vtrading">
      <div className="VtradingScreen__container">
        {vtradingModal && <Modal />}
        {vtradingAlertModal && <SellAlert />}

        <div className="VTradingScreen2__container">
          <div
            className={
              activePortfolio > 1 ? "Vtrading__next__active" : "Vtrading__next"
            }
            onClick={() =>
              activePortfolio > 1 && setActivePortfolioPage(activePortfolio - 1)
            }
          >
            <IoIosArrowBack size={30} />
          </div>

          <div
            className={
              activePortfolio < 3 ? "Vtrading__next__active" : "Vtrading__next"
            }
            onClick={() =>
              activePortfolio < 3 && setActivePortfolioPage(activePortfolio + 1)
            }
          >
            <IoIosArrowForward size={30} />
          </div>
          <div
            className="VtradingScreen2__TableContainer"
            style={{ background: "#EFF2F5" }}
          >
            {vtButton === "position" ? (
              <table className="Home__MainTable">
                <thead>
                  <tr>
                    <th></th>

                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                            justifyContent: "flex-start",
                          }}
                          className="Home__MainTable__pct"
                        >
                          <div style={{ cursor: "pointer" }}>Coin</div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByPrice();
                              setColumnName("price");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Quantity
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          <div
                            onClick={() => {
                              sortGlobalTickerBy24h();
                              setColumnName("24h%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Total Investment
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy7d();
                              setColumnName("7d%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Average Price
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          <div
                            onClick={() => {
                              sortGlobalTickerByMarketCap();
                              setColumnName("marketcap");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Current Price
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          <div style={{ cursor: "pointer" }}>P & L</div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div>
                          <p>% Ch</p>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(10).keys()].map((c,index) => (
                    <>
                      <tr key={index} className="Home__MainTable__link">
                        {[...Array(8).keys()].map((c, index) => (
                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <div
                                className="skeleton text"
                                style={{ width: positionWidth[index] }}
                              />
                            </div>
                          </td>
                        ))}
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            ) : vtButton === "history" ? (
              <table className="Home__MainTable">
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "name" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "name" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByName();
                              setColumnName("name");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Type
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "name" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "name" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByName();
                              setColumnName("name");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Coin
                          </div>
                        </div>
                      </div>
                    </th>

                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "price" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "price" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByPrice();
                              setColumnName("price");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Quantity
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "24h%" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "24h%" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy24h();
                              setColumnName("24h%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Price
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName && columnName === "7d%" && order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "7d%" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy7d();
                              setColumnName("7d%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Total Val
                          </div>
                        </div>
                      </div>
                    </th>

                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "volumeIn24h" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "volumeIn24h" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div style={{ cursor: "pointer" }}>Time</div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(10).keys()].map((c) => (
                    <>
                      <tr key={c._id} className="Home__MainTable__link">
                        {[...Array(7).keys()].map((c, i) => (
                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <div
                                className="skeleton text"
                                style={{ width: positionWidth[i] }}
                              />
                            </div>
                          </td>
                        ))}
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            ) : (
              <table className="Home__MainTable">
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "name" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "name" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByName();
                              setColumnName("name");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Type
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "name" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "name" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByName();
                              setColumnName("name");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Coin
                          </div>
                        </div>
                      </div>
                    </th>

                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "price" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "price" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByPrice();
                              setColumnName("price");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Quantity
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "24h%" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "24h%" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy24h();
                              setColumnName("24h%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Total Investment
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName && columnName === "7d%" && order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "7d%" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy7d();
                              setColumnName("7d%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Trigger Price
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(10).keys()].map((c) => (
                    <>
                      <tr key={c._id} className="Home__MainTable__link">
                        {[...Array(6).keys()].map((c, i) => (
                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <div
                                className="skeleton text"
                                style={{ width: positionWidth[i] }}
                              />
                            </div>
                          </td>
                        ))}
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/*<div className="VtradingScreen2__Footer">
          <div>&nbsp;</div>
          <div className="VtradingScreen2__buttons__group">
            <button className="SingleCrypto__grid__compare__button">
              Expert’s Portfolios
            </button>

            <button className="SingleCrypto__grid__moreinfo__button">
              Take Portfolio Tour
            </button>
          </div>
       
        </div> */}
      </div>
    </div>
  );
};

export default Vtrading;
